//LIBRARY
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

//RENDER

//CONSTANTS
import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";

import { STYLE_PROGRAM_GRID } from "../../../utils/useStyle";

//FUNCTION
import HomeClickToProgram from "../functions/Home.ClickToProgram";
import { FunctionFormatNewLine } from "../../../utils/useFunction";
import { FunctionSort } from "../../pricing/render/Pricing.Size";
import { ContextLanguage } from "../../../context/Context.Language";
// import FunctionRepleteFont from "../../../utils/FunctionRepleteFont";
import { useIsMobile } from "../../../utils/useIsMobile";

const HomeFunctionGetStyle = (type, status) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return status === true
      ? ` flex gap-3 md:gap-0 md:grid grid-cols-1 p-[14px] xl:py-4 xl:px-3.5  rounded-2xl text-laundry-gray-100 text-left md:text-center  cursor-pointer h-full  bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[344px] lg:w-[513px]  xl:w-program_home_mywash width_program  group `
      : ` flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return status === true
      ? ` flex gap-3 md:grid grid-cols-1  p-[14px] gap-3 md:gap-0 xl:p-0 rounded-2xl text-laundry-gray-100 text-center  cursor-pointer h-full  bg-laundry-mydryclean shadow-lg shadow-laundry-shadowyellow group`
      : ` flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return status === true
      ? `   flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px] group`
      : `  flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  bg-laundry-gray-30 text-laundry-gray-50 cursor-pointer  shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px] `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return status === true
      ? `  flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  md:py-4 md:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-[111px] lg:h-height_program_home width_program_shoes  group`
      : ` flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 w-full cursor-pointer  bg-laundry-gray-30 shadow-lg w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-height_program_home `;
  } else {
    return "";
  }
};

const HomeFunctionGetStyleMobile = (type, status) => {
  const { language } = React.useContext(ContextLanguage);

  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return status === true
      ? ` ${
          language === "TH" ? " h-[114px]  . " : "  h-118  3 "
        }  relative flex gap-3 md:gap-0 md:grid grid-cols-1 p-[14px] xl:py-4 xl:px-3.5  rounded-2xl text-laundry-gray-100 text-left md:text-center  cursor-pointer   bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[344px] lg:w-[513px]  xl:w-program_home_mywash width_program  group `
      : ` ${
          language === "TH" ? " h-[114px]  . " : "  h-118  4"
        }  relative flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return status === true
      ? ` h-[108px] relative flex gap-3 md:grid grid-cols-1  p-[14px] gap-3 md:gap-0 xl:p-0 rounded-2xl text-laundry-gray-100 text-center  cursor-pointer h-full  bg-laundry-mydryclean shadow-lg shadow-laundry-shadowyellow group`
      : ` h-[108px] relative flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return status === true
      ? ` ${
          language === "TH" ? " h-[85px]  . " : " h-[98px]  <41>. "
        } relative flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px] group`
      : ` ${
          language === "TH" ? " h-[85px]   . " : " h-[98px]  <42>. "
        } relative flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left md:py-4 md:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  bg-laundry-gray-30 text-laundry-gray-50 cursor-pointer  shadow-lg shadow-laundry-shadowgreen w-full md:w-[330px] lg:w-[407px] xl:w-program_home width_program_iron  justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-[26px] `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return status === true
      ? ` ${
          language === "TH" ? " h-[98px]  . " : " h-[98px]  <43>. "
        } relative flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  md:py-4 md:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-[111px] lg:h-height_program_home width_program_shoes  group`
      : ` ${
          language === "TH" ? " h-[98px]  . " : " h-[98px]  <44>. "
        } relative flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 w-full cursor-pointer  bg-laundry-gray-30 shadow-lg w-full md:w-[330px] lg:w-[407px] xl:w-program_home     row-span-2 h-height_program_home_mb md:h-height_program_home `;
  } else {
    return "";
  }
};

const HomeFunctionGetStyleSelect = (type, status) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return `${
      status === true
        ? ` flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full cursor-pointer h-full  bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program  group `
        : ` flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return status === true
      ? ` flex gap-3 md:grid grid-cols-1  p-[14px] gap-3 md:gap-0 xl:p-0 rounded-2xl text-laundry-gray-100 text-center  cursor-pointer h-full bg-laundry-mydryclean shadow-lg shadow-laundry-shadowyellow group`
      : ` flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return `${
      status === true
        ? `  flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[280px] lg:w-[398px] xl:w-program_home width_program_iron   justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-6 group `
        : ` flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100   bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  w-full md:w-[330px] lg:w-[407px] xl:w-program_home   justify-self-start md:h-h_120 md:-mt-6 `
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return status === true
      ? ` flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[280px] lg:w-[398px] xl:w-program_home row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes  group  `
      : ` flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 bg-laundry-gray-30  shadow-lg w-full md:w-[280px] lg:w-[398px] xl:w-program_home  row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes `;
  } else {
    return "";
  }
};

const HomeFunctionGetStyleSelectMobile = (type, status) => {
  const { language } = React.useContext(ContextLanguage);

  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return `${
      status === true
        ? `${
            language === "TH" ? " h-[105px] . " : "<x-1> h-118 . "
          }  relative flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full cursor-pointer   bg-laundry-mywash md:hover:bg-laundry-primary-blue md:hover:text-laundry-gray-200   shadow-lg shadow-laundry-shadowblue md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program  group `
        : `${
            language === "TH" ? " h-[105px] . " : "<x-2>  h-118 . "
          }  relative flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full    bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return status === true
      ? `h-[108px] relative flex gap-3 md:grid grid-cols-1  p-[14px] gap-3 md:gap-0 xl:p-0 rounded-2xl text-laundry-gray-100 text-center  cursor-pointer h-full bg-laundry-mydryclean shadow-lg shadow-laundry-shadowyellow group`
      : `h-[108px] relative flex gap-3 md:grid grid-cols-1  p-[14px]  xl:py-4 xl:px-3.5 rounded-2xl text-laundry-gray-100 text-left md:text-center w-full  h-full  bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  md:row-span-3 w-full md:w-[345px] lg:w-[474px]  xl:w-program_home_mywash_select width_program `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return `${
      status === true
        ? `${
            language === "TH" ? " h-[85px] . " : " h-[98px] <45>. "
          }  relative flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100  cursor-pointer bg-laundry-myiron md:hover:bg-laundry-hovermyiron shadow-lg shadow-laundry-shadowgreen w-full md:w-[280px] lg:w-[398px] xl:w-program_home width_program_iron   justify-self-start md:h-20 lg:h-h_120 md:-mt-5 lg:-mt-6 group `
        : `${
            language === "TH" ? " h-[85px] . " : " h-[98px] <46>. "
          } relative flex gap-3 md:justify-center items-center  md:gap-6 p-[14px] text-left xl:py-4 xl:px-3.5 2xl:px-[54px] rounded-2xl text-laundry-gray-100   bg-laundry-gray-30 text-laundry-gray-50 shadow-lg  w-full md:w-[330px] lg:w-[407px] xl:w-program_home   justify-self-start md:h-h_120 md:-mt-6 `
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return status === true
      ? `${
          language === "TH" ? " h-[98px] . " : " h-[98px] <47>. "
        } relative flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-100  cursor-pointer  bg-laundry-myshoes md:hover:bg-laundry-hovermyshoes shadow-lg shadow-laundry-shadowpink w-full md:w-[280px] lg:w-[398px] xl:w-program_home row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes  group  `
      : `${
          language === "TH" ? " h-[98px] . " : " h-[98px] <48>. "
        } relative flex gap-3 md:justify-center md:gap-6 text-left  p-[14px]  xl:py-4 xl:px-3.5 2xl:px-[54px] items-center rounded-2xl text-laundry-gray-50 bg-laundry-gray-30  shadow-lg w-full md:w-[280px] lg:w-[398px] xl:w-program_home  row-span-2 h-height_program_home_mb  md:h-[111px] lg:h-height_program_home width_program_shoes `;
  } else {
    return "";
  }
};

const HomeImgGetStyle = (type) => {
  const { language } = React.useContext(ContextLanguage);
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return ` my-auto md:mx-auto w-w_62_32 h-12 md:w-[67px] md:h-[67px] lg:w-icon_home lg:h-fit   `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return `  my-auto md:mx-auto w-w_62_32 h-12 md:w-[67px] md:h-[67px] lg:w-icon_home lg:h-fit `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return ` ${
      language === "TH" ? " md:mt-5 " : "md:mt-1"
    }  w-w_62_32 h-12 md:h-[56px] lg:h-h_100 md:w-auto `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return ` w-w_62_32 h-h_51_51 md:w-[67px] md:h-[67px] lg:w-icon_home lg:h-full    `;
  } else {
    return "";
  }
};

const HomeImgGetStyleMobile = (type) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return ` h-16 absolute top-1/2  transform -translate-y-1/2 left-5 `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return `  h-14 absolute top-1/2  transform -translate-y-1/2 left-5 `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return ` h-14 absolute top-1/2  transform -translate-y-1/2 left-5 `;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return ` h-[60px] absolute top-1/2  transform -translate-y-1/2 left-5  `;
  } else {
    return "";
  }
};

const HomeIcon = (type, status) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return `${
      status === true ? "/icons/mywash_white.svg" : "/icons/mywash_disable.svg"
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return `${
      status === true
        ? "/icons/mydryclean_white.svg"
        : "/icons/mydryclean_white.svg"
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return `${
      status === true ? "/icons/iron_white.svg" : "/icons/iron_disable.svg"
    }`;
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return `${
      status === true ? "/icons/shoes_white.svg" : "/icons/shoes_disable.svg"
    }`;
  }
};

const HomeRenderEachProgram = React.memo(({ data }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const { language } = React.useContext(ContextLanguage);

  if (data?.length > 0) {
    return (
      <React.Fragment>
        {isMobile ? (
          <div
            className={`${
              location.pathname === "/" || location.pathname === "/TH"
                ? "mt-6 md:mt-10"
                : "mt-5 md:mt-0"
            } ${STYLE_PROGRAM_GRID} ${isMobile ? "space-y-3" : ""}`}
          >
            {FunctionSort(data, [0, 2, 1])?.map((program, index) => {
              return (
                <div
                  key={`key-of-program-${index}`}
                  onClick={() => {
                    if (program?.status === true) {
                      // HomeClickToProgram(navigate, program?.type, program?._id);
                      if (program?.master_type === "My Wash") {
                        navigate("/MyWash");
                      } else if (program?.master_type === "My Shoes") {
                        navigate("/MyShoes");
                      } else if (program?.master_type === "My Iron") {
                        navigate("/MyIron");
                      }
                    } else {
                      return;
                    }
                  }}
                  className={
                    location.pathname === "/OurServices" ||
                    location.pathname === "/OurServices/TH"
                      ? ` ${HomeFunctionGetStyleSelectMobile(
                          program.type,
                          program?.status
                        )} `
                      : `${HomeFunctionGetStyleMobile(
                          program.type,
                          program?.status
                        )} `
                  }
                >
                  <img
                    className={`${HomeImgGetStyleMobile(program.type)} `}
                    src={`${HomeIcon(program.type, program.status)}`}
                  />
                  <div
                    className={`" col-span-5 md:col-auto ${
                      program?.status ? " md:hover:text-laudry-gray-200 " : ""
                    }  duration-500"`}
                  >
                    <div
                      className={`${
                        language === "TH"
                          ? "  text-base-th lg:text-lg-th font-NotoSansThai "
                          : "  text-base lg:text-lg font-Poppins "
                      } absolute top-[15px] left-[100px] font-bold md:group-hover:underline break-all first-letter: ${
                        program.type === "My Wash" ? "md:-mt-2" : ""
                      } `}
                    >
                      {program?.name}
                    </div>
                    <div
                      className={`${
                        language === "TH"
                          ? " text-xs-th md:text-base-th "
                          : " text-xs md:text-base "
                      } absolute top-10 left-[100px] leading-5 md:leading-6 mx-auto mt-1  md:mt-0 ${
                        program.type === "My Wash"
                          ? " w-[227px] md:w-[280px] "
                          : " w-[227px] "
                      }             
                  `}
                    >
                      {FunctionFormatNewLine(program?.description_mobile)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className={`${
              location.pathname === "/" || location.pathname === "/TH"
                ? "mt-6 md:mt-10"
                : "mt-5 md:mt-0"
            } ${STYLE_PROGRAM_GRID} ${isMobile ? "space-y-3" : ""}`}
          >
            {FunctionSort(data, [0, 2, 1])?.map((program, index) => {
              /* {data?.map((program, index) => { */
              return (
                <div
                  key={`key-of-program-${index}`}
                  onClick={() => {
                    if (program?.status === true) {
                      // HomeClickToProgram(navigate, program?.type, program?._id);
                      if (program?.master_type === "My Wash") {
                        navigate("/MyWash");
                      } else if (program?.master_type === "My Shoes") {
                        navigate("/MyShoes");
                      } else if (program?.master_type === "My Iron") {
                        navigate("/MyIron");
                      }
                    } else {
                      return;
                    }
                  }}
                  className={
                    location.pathname === "/OurServices" ||
                    location.pathname === "/OurServices/TH"
                      ? ` ${HomeFunctionGetStyleSelect(
                          program.type,
                          program?.status
                        )} `
                      : `${HomeFunctionGetStyle(
                          program.type,
                          program?.status
                        )} `
                  }
                >
                  <img
                    className={`${HomeImgGetStyle(program.type)} `}
                    src={`${HomeIcon(program.type, program.status)}`}
                  />
                  <div
                    className={`" col-span-5 md:col-auto ${
                      program?.status ? " md:hover:text-laudry-gray-200 " : ""
                    }  duration-500"`}
                  >
                    <div
                      className={` ${
                        language === "TH"
                          ? " text-base-th lg:text-lg-th font-NotoSansThai"
                          : " text-base lg:text-lg  font-Poppins"
                      } font-bold md:group-hover:underline break-all first-letter:
                  ${program.type === "My Wash" ? "md:-mt-2" : ""} `}
                    >
                      {program?.name}
                    </div>
                    <div
                      className={`${
                        language === "TH"
                          ? " text-xs-th md:text-base-th "
                          : " text-xs md:text-base "
                      }  leading-5 md:leading-6 mx-auto mt-1  md:mt-0 ${
                        program.type === "My Wash"
                          ? " w-[227px] md:w-[280px] "
                          : " w-[227px] "
                      }             
                  `}
                    >
                      {FunctionFormatNewLine(program?.description_mobile)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  } else {
    return <div className="h-screen bg-white" />;
  }
});

export default HomeRenderEachProgram;
